import { SkeletonTextSingle } from "features/CenterContent/RoleContent/ProductionDeviation/components/SkeletonTextSingle";
import { FC } from "react";
import { HStack, Text } from "shared/components/Spor";

type DirectionTextProps = {
  originStopName: string | null;
  destinationStopName: string | null;
};

export const DirectionDescriptor: FC<DirectionTextProps> = ({
  originStopName,
  destinationStopName,
}) => {
  if (!originStopName || !destinationStopName) {
    return (
      <HStack gap={0}>
        <SkeletonTextSingle />
        <Text fontWeight="bold">–</Text>
        <SkeletonTextSingle />
      </HStack>
    );
  }
  return (
    <Text fontWeight="bold">
      {originStopName}–{destinationStopName}
    </Text>
  );
};
